import { dotSlpxPair } from './config'
import { atom } from 'jotai'

export const slpxSubstratePairsState = atom([dotSlpxPair])
